import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, h } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";
import type { SegmentedOption } from "./types";

interface Props {
  modelValue?: string | number;
  options?: Array<string | number | SegmentedOption>;
  disabled?: boolean;
  size?: SizeType;
  block?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Segmented',
  props: {
    modelValue: { default: undefined },
    options: { default: () => [] },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    block: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const normalizedOptions = computed(() =>
  (props.options || []).map((opt) => {
    if (typeof opt === "string" || typeof opt === "number") {
      return { label: String(opt), value: opt };
    }
    if (opt.icon) {
      return {
        value: opt.value,
        disabled: opt.disabled,
        payload: opt,
        label: () =>
          h("span", { class: "ant-segmented-label" }, [
            h("i", { class: opt.icon }),
            opt.label ? h("span", opt.label) : null,
          ]),
      };
    }
    return {
      label: opt.label,
      value: opt.value,
      disabled: opt.disabled,
    };
  })
);

const innerValue = computed({
  get: () => props.modelValue as string | number,
  set: (val: string | number) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onChange = (val: string | number) => {
  emit("update:modelValue", val);
  emit("change", val);
};

return (_ctx: any,_cache: any) => {
  const _component_a_segmented = _resolveComponent("a-segmented")!

  return (_openBlock(), _createBlock(_component_a_segmented, {
    value: innerValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    options: normalizedOptions.value,
    disabled: _ctx.disabled,
    size: _ctx.size,
    block: _ctx.block,
    class: "ant-segmented",
    onChange: onChange
  }, null, 8, ["value", "options", "disabled", "size", "block"]))
}
}

})